export const BackBtnIcon = (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" fill="#fff">
    <path d="M257.5 445.1l-22.2 22.2c-9.4 9.4-24.6 9.4-33.9 0L7 273c-9.4-9.4-9.4-24.6 0-33.9L201.4 44.7c9.4-9.4 24.6-9.4 33.9 0l22.2 22.2c9.5 9.5 9.3 25-.4 34.3L136.6 216H424c13.3 0 24 10.7 24 24v32c0 13.3-10.7 24-24 24H136.6l120.5 114.8c9.8 9.3 10 24.8.4 34.3z" />
  </svg>
);

export const DashboardIcon = (
  <svg
    width="35"
    height="35"
    viewBox="0 0 35 35"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0 17.4444C0 18.549 0.895431 19.4444 2 19.4444H13.5556C14.6601 19.4444 15.5556 18.549 15.5556 17.4444V2C15.5556 0.895429 14.6601 0 13.5556 0H2C0.895432 0 0 0.895431 0 2V17.4444ZM0 33C0 34.1046 0.895431 35 2 35H13.5556C14.6601 35 15.5556 34.1046 15.5556 33V25.3333C15.5556 24.2288 14.6601 23.3333 13.5556 23.3333H2C0.895432 23.3333 0 24.2288 0 25.3333V33ZM19.4444 33C19.4444 34.1046 20.3399 35 21.4444 35H33C34.1046 35 35 34.1046 35 33V17.5556C35 16.451 34.1046 15.5556 33 15.5556H21.4444C20.3399 15.5556 19.4444 16.451 19.4444 17.5556V33ZM21.4444 0C20.3399 0 19.4444 0.89543 19.4444 2V9.66666C19.4444 10.7712 20.3399 11.6667 21.4444 11.6667H33C34.1046 11.6667 35 10.7712 35 9.66667V2C35 0.895432 34.1046 0 33 0H21.4444Z"
      fill="#F3F3F3"
    />
  </svg>
);

export const DataNotFoundIcon = (
  <svg
    width="1000"
    height="746"
    viewBox="0 0 1000 746"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M1000 655.4H0V654.9H1000V655.4Z" fill="#EBEBEB" />
    <path d="M833.6 687.1H899.8V687.6H833.6V687.1Z" fill="#EBEBEB" />
    <path d="M645.1 692.5H662.4V693H645.1V692.5Z" fill="#EBEBEB" />
    <path d="M793.2 668.5H831.6V669H793.2V668.5Z" fill="#EBEBEB" />
    <path d="M104.9 671.9H191.3V672.4H104.9V671.9Z" fill="#EBEBEB" />
    <path d="M209.1 671.9H221.8V672.4H209.1V671.9Z" fill="#EBEBEB" />
    <path d="M262.9 680.3H450.3V680.8H262.9V680.3Z" fill="#EBEBEB" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M474 565.7H87.8C81.5 565.7 76.4 560.6 76.4 554.3V11.4C76.4 5.1 81.5 0 87.8 0H474C480.3 0 485.4 5.1 485.4 11.4V554.3C485.4 560.6 480.3 565.7 474 565.7ZM87.8 0.5C81.8 0.5 76.9 5.4 76.9 11.4V554.3C76.9 560.3 81.8 565.2 87.8 565.2H474C480 565.2 484.9 560.3 484.9 554.3V11.4C484.9 5.4 480 0.5 474 0.5H87.8Z"
      fill="#EBEBEB"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M906.6 565.7H520.4C514.1 565.7 509 560.6 509 554.3V11.4C509 5.1 514.1 0 520.4 0H906.6C912.9 0 918 5.1 918 11.4V554.3C918 560.6 912.9 565.7 906.6 565.7ZM520.4 0.5C514.4 0.5 509.5 5.4 509.5 11.4V554.3C509.5 560.3 514.4 565.2 520.4 565.2H906.6C912.6 565.2 917.5 560.3 917.5 554.3V11.4C917.5 5.4 912.6 0.5 906.6 0.5H520.4Z"
      fill="#EBEBEB"
    />
    <path d="M579.4 238.2H854.9V57.8H579.4V238.2Z" fill="#E6E6E6" />
    <path d="M571 238.2H851V57.8H571V238.2Z" fill="#F0F0F0" />
    <path d="M579.4 238.2H854.9V273.6H579.4V238.2Z" fill="#E6E6E6" />
    <path d="M557 238.2H837V273.6H557V238.2Z" fill="#F0F0F0" />
    <path d="M839.2 226.4V69.5H582.7V226.4H839.2Z" fill="#FAFAFA" />
    <path d="M781.4 226.4L748.6 69.5H697.5L730.3 226.4H781.4Z" fill="white" />
    <path
      d="M833.8 214.7C834.3 214.7 834.6 214.4 834.6 213.9V77.2C834.6 76.7 834.3 76.4 833.8 76.4C833.3 76.4 833 76.7 833 77.2V213.9C833 214.4 833.3 214.7 833.8 214.7Z"
      fill="#F0F0F0"
    />
    <path d="M719.3 226.4L686.5 69.5H666.6L699.4 226.4H719.3Z" fill="white" />
    <path d="M584.2 226.4V69.5H582.7V226.4H584.2Z" fill="#E6E6E6" />
    <path
      opacity="0.6"
      d="M568.2 87.3H843.8L844.8 74.1H569.3L568.2 87.3Z"
      fill="#EBEBEB"
    />
    <path
      opacity="0.6"
      d="M568.2 108.9H843.8L844.8 95.7H569.3L568.2 108.9Z"
      fill="#EBEBEB"
    />
    <path
      opacity="0.6"
      d="M568.2 130.5H843.8L844.8 117.3H569.3L568.2 130.5Z"
      fill="#EBEBEB"
    />
    <path
      opacity="0.6"
      d="M568.2 152.1H843.8L844.8 138.9H569.3L568.2 152.1Z"
      fill="#EBEBEB"
    />
    <path
      opacity="0.6"
      d="M568.2 173.7H843.8L844.8 160.5H569.3L568.2 173.7Z"
      fill="#EBEBEB"
    />
    <path
      opacity="0.6"
      d="M568.2 195.3H843.8L844.8 182.1H569.3L568.2 195.3Z"
      fill="#EBEBEB"
    />
    <path d="M815.4 535.1H757.6V523.7H815.4V535.1Z" fill="#E6E6E6" />
    <path d="M648.6 654.9H659.3V392.8H648.6V654.9Z" fill="#E6E6E6" />
    <path d="M611.7 535.1H757.6V523.7H611.7V535.1Z" fill="#F5F5F5" />
    <path d="M815.4 597.4H757.6V586H815.4V597.4Z" fill="#E6E6E6" />
    <path d="M611.7 597.4H757.6V586H611.7V597.4Z" fill="#F5F5F5" />
    <path d="M815.4 410.4H757.6V399H815.4V410.4Z" fill="#E6E6E6" />
    <path d="M611.7 410.4H757.6V399H611.7V410.4Z" fill="#F5F5F5" />
    <path d="M815.4 472.7H757.6V461.3H815.4V472.7Z" fill="#E6E6E6" />
    <path d="M611.7 472.7H757.6V461.3H611.7V472.7Z" fill="#F5F5F5" />
    <path d="M794.5 654.9H805.2V392.8H794.5V654.9Z" fill="#E6E6E6" />
    <path d="M746.9 654.9H757.6V392.8H746.9V654.9Z" fill="#F5F5F5" />
    <path d="M611.7 654.9H622.3V392.8H611.7V654.9Z" fill="#F5F5F5" />
    <path d="M130.7 654.9H239.9V443.1H130.7V654.9Z" fill="#E6E6E6" />
    <path d="M159.9 654.9H130.7V625.7H190.5L159.9 654.9Z" fill="#FAFAFA" />
    <path d="M428.4 654.9H537.5V443.1H428.4V654.9Z" fill="#E6E6E6" />
    <path d="M130.7 644.8H453.8V443.1H130.7V644.8Z" fill="#FAFAFA" />
    <path d="M424.7 654.9H453.8V625.7H394.1L424.7 654.9Z" fill="#FAFAFA" />
    <path d="M153.4 568.8H431.2V518.3H153.4V568.8Z" fill="#F0F0F0" />
    <path d="M153.4 630H431.2V579.6H153.4V630Z" fill="#F0F0F0" />
    <path
      d="M206.2 523.7H378.4C383.4 523.7 387.5 519.6 387.5 514.5V513.9H197V514.5C197 519.6 201.1 523.7 206.2 523.7Z"
      fill="#FAFAFA"
    />
    <path d="M153.4 507.5H431.2V457H153.4V507.5Z" fill="#F0F0F0" />
    <path
      d="M206.2 462.4H378.4C383.4 462.4 387.5 458.3 387.5 453.3V452.6H197V453.3C197 458.3 201.1 462.4 206.2 462.4Z"
      fill="#FAFAFA"
    />
    <path
      d="M206.2 585H378.4C383.4 585 387.5 580.9 387.5 575.8V575.2H197V575.8C197 580.9 201.1 585 206.2 585Z"
      fill="#FAFAFA"
    />
    <path d="M148.1 238.2H423.7V57.8H148.1V238.2Z" fill="#E6E6E6" />
    <path d="M139.7 238.2H419.8V57.8H139.7V238.2Z" fill="#F0F0F0" />
    <path d="M148.1 238.2H423.7V273.6H148.1V238.2Z" fill="#E6E6E6" />
    <path d="M125.7 238.2H405.8V273.6H125.7V238.2Z" fill="#F0F0F0" />
    <path d="M408 226.4V69.5H151.5V226.4H408Z" fill="#FAFAFA" />
    <path d="M350.2 226.4L317.4 69.5H266.3L299 226.4H350.2Z" fill="white" />
    <path
      d="M402.5 214.7C403 214.7 403.4 214.4 403.4 213.9V77.2C403.4 76.7 403 76.4 402.5 76.4C402.1 76.4 401.7 76.7 401.7 77.2V213.9C401.7 214.4 402.1 214.7 402.5 214.7Z"
      fill="#F0F0F0"
    />
    <path d="M288.1 226.4L255.3 69.5H235.4L268.1 226.4H288.1Z" fill="white" />
    <path d="M153 226.4V69.5H151.5V226.4H153Z" fill="#E6E6E6" />
    <path
      opacity="0.6"
      d="M136.9 87.3H412.5L413.6 74.1H138L136.9 87.3Z"
      fill="#EBEBEB"
    />
    <path
      opacity="0.6"
      d="M136.9 94.7H412.5L413.6 81.5H138L136.9 94.7Z"
      fill="#EBEBEB"
    />
    <path
      opacity="0.6"
      d="M136.9 102.1H412.5L413.6 89H138L136.9 102.1Z"
      fill="#EBEBEB"
    />
    <path
      opacity="0.6"
      d="M136.9 109.6H412.5L413.6 96.4H138L136.9 109.6Z"
      fill="#EBEBEB"
    />
    <path
      opacity="0.6"
      d="M136.9 117H412.5L413.6 103.8H138L136.9 117Z"
      fill="#EBEBEB"
    />
    <path
      opacity="0.6"
      d="M136.9 124.4H412.5L413.6 111.3H138L136.9 124.4Z"
      fill="#EBEBEB"
    />
    <path d="M192 436.6H201.6V330.5H192V436.6Z" fill="#F5F5F5" />
    <path d="M193.3 436.6H195.9V330.4H193.3V436.6Z" fill="#FAFAFA" />
    <path d="M197.1 436.6H198.1V330.4H197.1V436.6Z" fill="#FAFAFA" />
    <path
      d="M161.5 443.1H232.1C232.1 438.2 228.1 434.2 223.2 434.2H170.4C165.5 434.2 161.5 438.2 161.5 443.1Z"
      fill="#F0F0F0"
    />
    <path
      d="M179.7 396.4C181.2 396.4 182.4 395.1 182.4 393.6V324C182.4 322.5 181.2 321.3 179.7 321.3C178.2 321.3 176.9 322.5 176.9 324V393.6C176.9 395.1 178.2 396.4 179.7 396.4Z"
      fill="#F0F0F0"
    />
    <path d="M154.1 355.7H239.4L229.6 296.1H164L154.1 355.7Z" fill="#E0E0E0" />
    <path
      d="M887.8 722.6C887.8 735.1 714.2 745.2 500 745.2C285.8 745.2 112.2 735.1 112.2 722.6C112.2 710.1 285.8 699.9 500 699.9C714.2 699.9 887.8 710.1 887.8 722.6Z"
      fill="#F5F5F5"
    />
    <path
      d="M208.9 331.8L206.2 295L208.2 294.8L210.9 331.7L208.9 331.8Z"
      fill="#A6E1DF"
    />
    <path
      d="M211.3 364.8L210.3 350.9L212.3 350.7L213.3 364.6L211.3 364.8Z"
      fill="#A6E1DF"
    />
    <path
      d="M675.4 520.4H247.1C237.4 520.4 228.9 512.5 228.2 502.8L207.2 210.5C206.5 200.9 213.8 192.9 223.5 192.9H651.8C661.5 192.9 670 200.9 670.7 210.5L691.8 502.8C692.5 512.5 685.1 520.4 675.4 520.4Z"
      fill="#A6E1DF"
    />
    <path
      d="M677.1 520.4H248.7C239.1 520.4 230.6 512.5 229.9 502.8L208.8 210.5C208.1 200.9 215.5 192.9 225.2 192.9H653.5C663.2 192.9 671.7 200.9 672.4 210.5L693.4 502.8C694.1 512.5 686.8 520.4 677.1 520.4Z"
      fill="#A6E1DF"
    />
    <path
      opacity="0.5"
      d="M677.1 520.4H248.7C239.1 520.4 230.6 512.5 229.9 502.8L208.8 210.5C208.1 200.9 215.5 192.9 225.2 192.9H653.5C663.2 192.9 671.7 200.9 672.4 210.5L693.4 502.8C694.1 512.5 686.8 520.4 677.1 520.4Z"
      fill="white"
    />
    <path
      d="M654.1 201.7H225.8C225.333 201.7 224.867 201.733 224.4 201.8C213.4 202.7 215.7 219.4 226.7 219.4H655.7C666.8 219.4 666.6 202.7 655.6 201.8C655.067 201.733 654.567 201.7 654.1 201.7Z"
      fill="#A6E1DF"
    />
    <path
      d="M237 210.5C237.1 212.8 235.4 214.6 233.2 214.6C231 214.6 229 212.8 228.9 210.5C228.7 208.3 230.4 206.5 232.6 206.5C234.9 206.5 236.8 208.3 237 210.5Z"
      fill="#FAFAFA"
    />
    <path
      d="M250.7 210.5C250.9 212.8 249.2 214.6 246.9 214.6C244.7 214.6 242.8 212.8 242.6 210.5C242.5 208.3 244.1 206.5 246.4 206.5C248.6 206.5 250.5 208.3 250.7 210.5Z"
      fill="#FAFAFA"
    />
    <path
      d="M264.4 210.5C264.6 212.8 262.9 214.6 260.7 214.6C258.5 214.6 256.5 212.8 256.4 210.5C256.2 208.3 257.9 206.5 260.1 206.5C262.3 206.5 264.3 208.3 264.4 210.5Z"
      fill="#FAFAFA"
    />
    <path
      d="M665.7 491.3H255.9C252.4 491.3 249.3 488.4 249.1 484.9L231.8 244.5C231.5 241 234.1 238.1 237.7 238.1H647.5C651 238.1 654.1 241 654.3 244.5L671.6 484.9C671.9 488.4 669.2 491.3 665.7 491.3Z"
      fill="white"
    />
    <path
      d="M493.1 399.7L486.4 307.1L466.2 294.9H410.6L418.1 399.7H493.1Z"
      fill="white"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M493.1 400.7H418.1C417.6 400.7 417.2 400.3 417.1 399.8L409.6 295C409.6 294.7 409.7 294.4 409.9 294.2C410 294 410.3 293.9 410.6 293.9H466.2C466.333 293.9 466.5 293.967 466.7 294.1L486.9 306.2C487.2 306.4 487.3 306.7 487.4 307L494 399.6C494 399.9 494 400.2 493.8 400.4C493.6 400.6 493.3 400.7 493.1 400.7ZM419 398.7H492L485.5 307.6L465.9 295.9H411.6L419 398.7Z"
      fill="#A6E1DF"
    />
    <path d="M486.4 307.1L466.2 294.9L473.6 311L486.4 307.1Z" fill="#EBEBEB" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M473.6 312C473.2 312 472.9 311.8 472.7 311.4L465.3 295.3C465.1 294.9 465.2 294.5 465.5 294.2C465.8 293.9 466.3 293.8 466.7 294.1L486.9 306.2C487.2 306.4 487.4 306.8 487.4 307.2C487.3 307.6 487 307.9 486.7 308L473.9 311.9C473.767 311.967 473.667 312 473.6 312ZM468.4 297.3L474.1 309.8L484 306.8L468.4 297.3Z"
      fill="#A6E1DF"
    />
    <path
      d="M441.9 342.1C442.1 344.4 440.3 346.3 438 346.3C435.7 346.3 433.6 344.4 433.5 342.1C433.3 339.8 435.1 337.9 437.4 337.9C439.7 337.9 441.8 339.8 441.9 342.1Z"
      fill="#A6E1DF"
    />
    <path
      d="M469.4 342.1C469.6 344.4 467.8 346.3 465.5 346.3C463.1 346.3 461.1 344.4 460.9 342.1C460.8 339.8 462.5 337.9 464.9 337.9C467.2 337.9 469.2 339.8 469.4 342.1Z"
      fill="#A6E1DF"
    />
    <path
      d="M477.2 369.6C476.7 369.6 476.2 369.2 476.2 368.7C475.7 361.9 465 356.3 452.4 356.3C444 356.3 436.5 358.8 432.8 362.8C431.133 364.6 430.367 366.5 430.5 368.5C430.5 369.1 430.1 369.5 429.6 369.6C429.1 369.6 428.6 369.2 428.6 368.7C428.4 366.1 429.4 363.7 431.4 361.5C435.4 357.1 443.5 354.4 452.4 354.4C466.3 354.4 477.6 360.6 478.1 368.5C478.2 369.1 477.8 369.5 477.2 369.6Z"
      fill="#A6E1DF"
    />
    <path
      d="M426.3 333.5C426.1 333.5 425.9 333.433 425.7 333.3C425.3 332.9 425.3 332.3 425.6 331.9L429.9 327.3C430.2 326.9 430.8 326.9 431.2 327.3C431.6 327.6 431.7 328.3 431.3 328.6L427 333.2C426.9 333.4 426.6 333.5 426.3 333.5Z"
      fill="#A6E1DF"
    />
    <path
      d="M475.2 333.5C474.933 333.5 474.7 333.433 474.5 333.3L469.6 328.7C469.2 328.3 469.2 327.7 469.6 327.3C469.9 326.9 470.5 326.9 470.9 327.3L475.8 331.9C476.2 332.2 476.2 332.8 475.9 333.2C475.7 333.4 475.4 333.5 475.2 333.5Z"
      fill="#A6E1DF"
    />
    <path
      d="M404.5 420.4H409L415.6 429.1L414.9 420.4H419.5L420.6 436.1H416.1L409.6 427.5L410.2 436.1H405.6L404.5 420.4Z"
      fill="black"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M422.7 428.2C422.5 425.667 423.067 423.7 424.4 422.3C425.733 420.833 427.667 420.1 430.2 420.1C432.8 420.1 434.867 420.8 436.4 422.2C437.867 423.6 438.7 425.567 438.9 428.1C439.033 429.967 438.833 431.467 438.3 432.6C437.767 433.8 436.933 434.733 435.8 435.4C434.667 436 433.233 436.3 431.5 436.3C429.767 436.3 428.3 436.033 427.1 435.5C425.9 434.9 424.9 434 424.1 432.8C423.3 431.6 422.833 430.067 422.7 428.2ZM427.5 428.3C427.633 429.833 428 430.967 428.6 431.7C429.267 432.367 430.1 432.7 431.1 432.7C432.167 432.7 432.967 432.367 433.5 431.7C433.967 431.033 434.133 429.833 434 428.1C433.933 426.567 433.567 425.467 432.9 424.8C432.3 424.133 431.467 423.8 430.4 423.8C429.467 423.8 428.7 424.133 428.1 424.8C427.567 425.533 427.367 426.7 427.5 428.3Z"
      fill="black"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M448.3 420.4H455.5C456.9 420.4 458.067 420.6 459 421C459.867 421.4 460.633 421.933 461.3 422.6C461.9 423.333 462.367 424.167 462.7 425.1C463.033 426.1 463.233 427.133 463.3 428.2C463.433 429.867 463.333 431.167 463 432.1C462.667 433.033 462.2 433.8 461.6 434.4C460.933 435 460.233 435.4 459.5 435.6C458.433 435.933 457.467 436.1 456.6 436.1H449.4L448.3 420.4ZM453.4 423.9L454 432.5H455.2C456.2 432.5 456.933 432.367 457.4 432.1C457.8 431.9 458.1 431.533 458.3 431C458.5 430.4 458.567 429.467 458.5 428.2C458.367 426.6 458 425.467 457.4 424.8C456.8 424.2 455.867 423.9 454.6 423.9H453.4Z"
      fill="black"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M474.9 433.5H469.4L468.8 436.1H463.9L468.6 420.4H473.9L480.9 436.1H475.9L474.9 433.5ZM473.6 430.1L471.5 424.5L470.2 430.1H473.6Z"
      fill="black"
    />
    <path
      d="M478.7 420.4H493.5L493.7 424.3H488.8L489.6 436.1H484.8L484 424.3H479L478.7 420.4Z"
      fill="black"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M504.7 433.5H499.2L498.7 436.1H493.7L498.5 420.4H503.8L510.8 436.1H505.7L504.7 433.5ZM503.5 430.1L501.3 424.5L500 430.1H503.5Z"
      fill="black"
    />
    <path
      d="M707.4 236.3C709.2 235.4 711.3 234.2 713.3 233.1C715.3 232.033 717.267 230.9 719.2 229.7C723.1 227.3 727.1 224.9 730.8 222.2C738.4 217 745.5 211.2 751.9 204.9C752.7 204.2 753.4 203.3 754.2 202.5L755.3 201.3L755.9 200.7L756.2 200.4C756.3 200.3 756.2 200.3 756.2 200.3L756.1 200.4C755.9 201 756.1 200.8 756.2 200.3C756.3 199.8 756.5 199 756.5 198.1C756.6 194.5 755.9 189.9 755 185.5C753.3 176.5 750.6 167.3 747.9 158.2L755.7 154.8C760.5 163.5 764.6 172.4 767.9 182C769.5 186.9 770.9 191.8 771.3 197.8C771.4 199.4 771.4 201 771.2 202.8C770.9 204.7 770.4 206.9 768.7 209.4L768.4 209.9L768.1 210.2L767.8 210.6L767.2 211.3L766 212.8C765.1 213.8 764.3 214.9 763.5 215.8C756.6 223.4 748.9 230.2 740.7 236.1C736.6 239.1 732.5 241.9 728.1 244.5C725.967 245.767 723.8 247 721.6 248.2C719.3 249.5 717.2 250.6 714.6 251.8L707.4 236.3Z"
      fill="#FFB573"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M686.4 705.6C685.867 705.067 685.633 704.367 685.7 703.5C685.8 702.8 686.2 702.5 686.5 702.4C688.5 701.5 693.6 704.8 694.1 705.1C694.3 705.2 694.3 705.4 694.3 705.5C694.3 705.7 694.2 705.8 694 705.9C692.8 706.1 691.1 706.5 689.6 706.5C688.3 706.5 687.1 706.2 686.4 705.6ZM686.9 703.1C686.7 703.1 686.6 703.3 686.5 703.6C686.433 704.2 686.567 704.667 686.9 705C687.8 705.8 690 705.9 692.9 705.3C690.8 704 687.9 702.6 686.9 703.1Z"
      fill="#A6E1DF"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M693.7 705.8C692.1 704.9 689.1 701.3 689.5 699.4C689.5 699 689.8 698.4 690.8 698.3C691.4 698.233 691.967 698.4 692.5 698.8C694.3 700.4 694.3 705.3 694.3 705.5C694.3 705.633 694.233 705.733 694.1 705.8C694.033 705.867 693.967 705.9 693.9 705.9C693.833 705.9 693.767 705.867 693.7 705.8ZM690.9 699.1C690.4 699.1 690.3 699.4 690.2 699.6C690 700.7 691.9 703.4 693.5 704.7C693.4 703.1 693 700.4 691.9 699.4C691.7 699.2 691.433 699.1 691.1 699.1C691.033 699.1 690.967 699.1 690.9 699.1Z"
      fill="#A6E1DF"
    />
    <path
      d="M692.4 186.2C690.5 196.2 686.4 216.3 693.3 222.9C693.3 222.9 690.6 233 672.2 233C651.8 233 662.5 222.9 662.5 222.9C673.5 220.3 673.2 212.1 671.3 204.3L692.4 186.2Z"
      fill="#FFB573"
    />
    <path
      d="M658.6 226.9C655.4 227.4 658.1 219.1 659.4 218.3C662.4 216.3 701.1 213.5 700.8 218.2C700.7 220.2 699.7 224.2 698 225.5C696.3 226.8 686.4 222.8 658.6 226.9Z"
      fill="#263238"
    />
    <path
      d="M664.9 224.2C662.3 225 662.6 216.7 663.4 215.7C665.4 213.4 696.8 205.3 697.7 209.9C698.1 211.9 698.2 215.8 697.2 217.3C696.1 218.8 686.9 216.3 664.9 224.2Z"
      fill="#263238"
    />
    <path
      d="M653.2 168.3C653 168.3 652.7 168.2 652.6 168C650.3 165.3 647.4 165.6 647.4 165.6C646.9 165.6 646.6 165.3 646.5 164.9C646.5 164.4 646.8 164 647.2 164C647.4 164 651 163.6 653.8 167C654.1 167.4 654 167.9 653.7 168.1C653.567 168.233 653.4 168.3 653.2 168.3Z"
      fill="#263238"
    />
    <path
      d="M649.3 178.1C649.3 178.1 647.6 184.1 645.4 187.2C647.3 188.6 650.3 187.6 650.3 187.6L649.3 178.1Z"
      fill="#FF5652"
    />
    <path
      d="M650.3 175.7C650.5 177 649.8 178.2 649 178.3C648.1 178.4 647.3 177.3 647.1 176C647 174.6 647.6 173.5 648.5 173.4C649.4 173.3 650.2 174.3 650.3 175.7Z"
      fill="#263238"
    />
    <path
      d="M648.9 173.4L645.6 172.8C645.6 172.8 647.5 175.2 648.9 173.4Z"
      fill="#263238"
    />
    <path d="M713.4 705.5H696.6L698 666.7H714.7L713.4 705.5Z" fill="#FFB573" />
    <path
      d="M695.3 703.5H714.1C714.8 703.5 715.4 704 715.5 704.7L717.6 719.6C717.8 721.1 716.5 722.6 714.9 722.5C708.4 722.4 705.2 722 696.9 722C691.8 722 684.4 722.6 677.4 722.6C670.5 722.6 670 715.6 672.9 715C686 712.2 688.1 708.3 692.5 704.6C693.3 703.9 694.3 703.5 695.3 703.5Z"
      fill="#263238"
    />
    <g opacity="0.2">
      <path d="M714.7 666.7H698L697.3 686.7H714L714.7 666.7Z" fill="black" />
    </g>
    <path
      d="M646.7 246.2C636.4 242.1 626.5 237.7 616.6 232.7C606.8 227.6 597.1 222.3 587.8 215.1C585.5 213.3 583.2 211.3 581 209C580.4 208.4 579.9 207.8 579.3 207.1C578.8 206.4 578.3 206 577.6 204.9C576.2 202.9 575.2 200.3 574.9 197.7C574.6 195 575.1 192.5 575.9 190.4C576.6 188.4 577.6 186.7 578.7 185.2C580.8 182.3 583.1 180.1 585.5 178.2C590.2 174.3 595.1 171.5 600.1 168.8C602.567 167.533 605.067 166.333 607.6 165.2C610.2 164.1 612.7 163.1 615.5 162.2L619 169.9C610.3 175.4 601.2 181.4 594.6 188.2C593 189.9 591.6 191.6 590.7 193.2C589.7 194.7 589.8 195.9 589.9 195.8C590 195.8 590 195.8 590.2 196L591 196.9C591.3 197.2 591.7 197.6 592.1 198C593.7 199.4 595.5 200.9 597.5 202.3C601.5 205.1 605.8 207.8 610.4 210.2C614.867 212.733 619.467 215.133 624.2 217.4C633.7 221.9 643.4 226.3 653 230.2L646.7 246.2Z"
      fill="#FFB573"
    />
    <path
      d="M623.9 164.4L626.7 158.4L614.1 154C614.1 154 610.2 165.8 614.9 171.3C618.8 170.6 622.3 168.1 623.9 164.4Z"
      fill="#FFB573"
    />
    <path
      d="M626.7 145.4L616.6 142.5L614.1 154L626.7 158.4V145.4Z"
      fill="#FFB573"
    />
    <path
      d="M756.7 159L758.2 144.9L745.2 148C745.2 148 745 161.2 751.9 163.2L756.7 159Z"
      fill="#FFB573"
    />
    <path
      d="M751.9 135.1L743.5 139.1L745.2 148L758.2 144.9L751.9 135.1Z"
      fill="#FFB573"
    />
    <path
      d="M695.1 166.6C695.7 183.2 696.3 190.2 688.8 199.5C677.5 213.5 657 210.6 651.4 194.5C646.4 180.1 646.2 155.3 661.8 147.2C677 139.1 694.5 150 695.1 166.6Z"
      fill="#FFB573"
    />
    <path
      d="M687.8 199.5C704.2 192.5 714.9 177.6 710.4 154.4C706 132.1 691 129.9 684.8 134.5C678.6 139.2 663.2 132.3 653.9 140.1C637.8 153.6 653 168.2 660.9 176.8C665.6 186.5 671.8 206.4 687.8 199.5Z"
      fill="#263238"
    />
    <path
      d="M681.1 150.4C686.6 158.3 697.1 160.6 704.6 155.4C712.2 150.2 713.8 139.5 708.3 131.6C702.8 123.6 692.2 121.3 684.7 126.5C677.2 131.7 675.6 142.4 681.1 150.4Z"
      fill="#A6E1DF"
    />
    <path
      d="M685.3 136.1C683 122.7 695.6 112.4 712.6 117.4C729.5 122.4 720.6 137.4 717.1 149.4C713.6 161.4 722.7 172.8 726.5 163.7C730.4 154.5 723.9 151.7 723.9 151.7C723.9 151.7 741.9 156.4 725.2 176.7C708.5 197 693.4 174.6 697.5 161.3C700.8 150.7 687.5 148.8 685.3 136.1Z"
      fill="#263238"
    />
    <path
      d="M668.4 141.2C660.6 137.1 647.5 133.9 640.1 146.4C636.5 152.3 637.9 160.4 637.9 160.4L660.7 161.9L668.4 141.2Z"
      fill="#263238"
    />
    <path
      d="M635.2 156.5C634.9 156.4 634.7 156.2 634.7 155.9C634.7 155.6 635.3 147.5 640.2 142.5C651.9 130.3 665.7 140.4 669.6 143.8C669.8 144 669.8 144.3 669.6 144.5C669.5 144.7 669.1 144.7 668.9 144.6C665.2 141.3 652 131.6 640.9 143.2C636.3 148 635.7 155.9 635.7 156C635.7 156.3 635.5 156.5 635.2 156.5Z"
      fill="#263238"
    />
    <path
      d="M663.7 176.2C663.7 179.4 662.2 182.6 660.4 184.7C657.6 188 654.5 186.4 653.7 182.8C653.1 179.6 653.7 174 657.2 172C660.7 170.1 663.7 172.5 663.7 176.2Z"
      fill="#FFB573"
    />
    <path
      d="M660.1 328.3C660.1 328.3 661.2 444.6 671.3 509.4C679.4 561.8 694.5 682.8 694.5 682.8H717.3C717.3 682.8 719.6 566 715.4 514.2C705 383.2 732 358.7 710.2 328.3H660.1Z"
      fill="#263238"
    />
    <path
      opacity="0.1"
      d="M660.1 328.3C660.1 328.3 661.2 444.6 671.3 509.4C679.4 561.8 694.5 682.8 694.5 682.8H717.3C717.3 682.8 719.6 566 715.4 514.2C705 383.2 732 358.7 710.2 328.3H660.1Z"
      fill="white"
    />
    <path
      opacity="0.3"
      d="M672.1 381.1C680.1 416.2 673.7 471.5 669.4 495.8C664.7 458.9 662.4 411 661.2 375.9C665.4 369.1 669.3 368.7 672.1 381.1Z"
      fill="black"
    />
    <path
      d="M691.4 683.3H720.5L722 673.1L691.2 672L691.4 683.3Z"
      fill="#A6E1DF"
    />
    <path
      d="M699.7 230.2C702.4 224.7 717.1 221.3 725.2 221.3L731.2 248.1C731.2 248.1 715.2 271.8 708.5 269.3C700.6 266.3 693.8 241.8 699.7 230.2Z"
      fill="#A6E1DF"
    />
    <path
      opacity="0.4"
      d="M699.7 230.2C702.4 224.7 717.1 221.3 725.2 221.3L731.2 248.1C731.2 248.1 715.2 271.8 708.5 269.3C700.6 266.3 693.8 241.8 699.7 230.2Z"
      fill="black"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M682.7 676.8C680.8 678.8 677.3 682.2 674.9 681.9C674.167 681.833 673.567 681.467 673.1 680.8C672.9 680.4 672.9 679.967 673.1 679.5C674.1 677.4 681.5 676.3 682.3 676.1C682.5 676.1 682.6 676.2 682.7 676.3C682.767 676.433 682.767 676.567 682.7 676.7C682.7 676.767 682.7 676.8 682.7 676.8ZM673.8 679.9C673.733 680.033 673.733 680.2 673.8 680.4C674.067 680.867 674.433 681.1 674.9 681.1C676.3 681.3 678.6 679.8 681.3 677.1C678.3 677.6 674.5 678.7 673.8 679.8C673.8 679.8 673.8 679.833 673.8 679.9Z"
      fill="#A6E1DF"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M682.4 676.9C680.3 677.4 675 676.8 674.1 675C673.9 674.6 673.8 674 674.7 673.3C675.3 672.7 676 672.433 676.8 672.5C679.6 672.7 682.5 676.1 682.7 676.3C682.767 676.367 682.767 676.467 682.7 676.6C682.7 676.667 682.7 676.7 682.7 676.7C682.633 676.833 682.533 676.9 682.4 676.9ZM674.8 674.7C675.3 675.7 679.2 676.4 681.6 676.2C680.6 675.3 678.6 673.4 676.8 673.3C676.2 673.233 675.667 673.4 675.2 673.8C675.067 674 674.967 674.133 674.9 674.2C674.7 674.5 674.8 674.6 674.8 674.7Z"
      fill="#A6E1DF"
    />
    <path
      d="M700.2 669.6L684.8 676.4L678 662.2L669.1 643.6L668 641.5L683.4 634.6L684.5 637.1L693.2 655.1L700.2 669.6Z"
      fill="#FFB573"
    />
    <path
      opacity="0.2"
      d="M693.2 655.1L678 662.2L669.1 643.6L684.5 637.1L693.2 655.1Z"
      fill="black"
    />
    <path
      d="M642.1 328.3C642.1 328.3 593.2 450 606.5 507.3C618.4 559.1 671.5 657.1 671.5 657.1L692 646.9C692 646.9 659.2 528.5 655.6 502.8C648.7 452.7 693.2 382.1 693.2 328.3H642.1Z"
      fill="#263238"
    />
    <path
      opacity="0.1"
      d="M642.1 328.3C642.1 328.3 593.2 450 606.5 507.3C618.4 559.1 671.5 657.1 671.5 657.1L692 646.9C692 646.9 659.2 528.5 655.6 502.8C648.7 452.7 693.2 382.1 693.2 328.3H642.1Z"
      fill="white"
    />
    <path
      d="M682.1 674.3L697.3 663.2C697.9 662.8 698.6 662.9 699.1 663.4L709.6 674.1C710.7 675.3 710.5 677.2 709.2 678.1C703.8 681.9 701 683.5 694.3 688.3C690.2 691.3 682 697.9 676.3 702.1C670.7 706.1 666.2 700.8 668.2 698.6C677.2 688.6 679.1 682.4 680.5 676.8C680.7 675.8 681.3 674.9 682.1 674.3Z"
      fill="#263238"
    />
    <path
      d="M670.1 661.5L696.6 649.4L693.2 638.6L664.9 651.5L670.1 661.5Z"
      fill="#A6E1DF"
    />
    <path
      d="M655.1 228.8C652.9 223.1 633.8 216.9 624.2 214.7L620 246.3C620 246.3 635.7 268.8 642.5 266.9C650.7 264.7 659.8 241 655.1 228.8Z"
      fill="#A6E1DF"
    />
    <path
      opacity="0.4"
      d="M655.1 228.8C652.9 223.1 633.8 216.9 624.2 214.7L620 246.3C620 246.3 635.7 268.8 642.5 266.9C650.7 264.7 659.8 241 655.1 228.8Z"
      fill="black"
    />
    <path
      d="M634.1 227.2C634.1 227.2 626.2 230 642.1 328.3C669.1 328.3 697 328.3 710.2 328.3C709 300.7 709 283.6 722.2 226.7C722.2 226.7 708 223.6 693.3 222.9C681.9 222.4 672.5 222 662.5 222.9C649.2 224.2 634.1 227.2 634.1 227.2Z"
      fill="#A6E1DF"
    />
    <path
      opacity="0.4"
      d="M634.1 227.2C634.1 227.2 626.2 230 642.1 328.3C669.1 328.3 697 328.3 710.2 328.3C709 300.7 709 283.6 722.2 226.7C722.2 226.7 708 223.6 693.3 222.9C681.9 222.4 672.5 222 662.5 222.9C649.2 224.2 634.1 227.2 634.1 227.2Z"
      fill="black"
    />
    <path
      d="M711.2 324.4L714.3 330.4C714.5 330.9 713.9 331.4 713.2 331.4H641.8C641.2 331.4 640.7 331.1 640.6 330.7L640 324.6C640 324.2 640.5 323.8 641.2 323.8H710.1C710.6 323.8 711 324 711.2 324.4Z"
      fill="#A6E1DF"
    />
    <path
      opacity="0.3"
      d="M711.2 324.4L714.3 330.4C714.5 330.9 713.9 331.4 713.2 331.4H641.8C641.2 331.4 640.7 331.1 640.6 330.7L640 324.6C640 324.2 640.5 323.8 641.2 323.8H710.1C710.6 323.8 711 324 711.2 324.4Z"
      fill="white"
    />
    <path
      d="M701.9 332.1H703.8C704.2 332.1 704.4 331.9 704.4 331.6L703.5 323.7C703.5 323.5 703.2 323.3 702.8 323.3H701C700.6 323.3 700.3 323.5 700.4 323.7L701.2 331.6C701.3 331.9 701.6 332.1 701.9 332.1Z"
      fill="#263238"
    />
    <path
      d="M657.2 332.1H659.1C659.4 332.1 659.7 331.9 659.7 331.6L658.8 323.7C658.8 323.5 658.5 323.3 658.1 323.3H656.3C655.9 323.3 655.6 323.5 655.6 323.7L656.5 331.6C656.5 331.9 656.8 332.1 657.2 332.1Z"
      fill="#263238"
    />
  </svg>
);

export const ConvertIcon = (
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
    <g
      id="SVGRepo_tracerCarrier"
      strokeLinecap="round"
      strokeLinejoin="round"
    ></g>
    <g id="SVGRepo_iconCarrier">
      <path
        d="M15.0002 22.7483C14.7302 22.7483 14.4802 22.5983 14.3502 22.3683C14.2202 22.1283 14.2202 21.8483 14.3602 21.6083L15.4102 19.8583C15.6202 19.4983 16.0902 19.3883 16.4402 19.5983C16.8002 19.8083 16.9102 20.2683 16.7002 20.6283L16.4302 21.0783C19.1902 20.4283 21.2602 17.9483 21.2602 14.9883C21.2602 14.5783 21.6002 14.2383 22.0102 14.2383C22.4202 14.2383 22.7602 14.5783 22.7602 14.9883C22.7502 19.2683 19.2702 22.7483 15.0002 22.7483Z"
        fill="#FFFFFF"
      ></path>
      <path
        d="M2 9.75C1.59 9.75 1.25 9.41 1.25 9C1.25 4.73 4.73 1.25 9 1.25C9.27 1.25 9.52 1.4 9.65 1.63C9.78 1.87 9.78 2.15 9.64 2.39L8.59 4.14C8.38 4.49 7.92 4.61 7.56 4.39C7.21 4.18 7.09 3.72 7.31 3.36L7.58 2.91C4.81 3.56 2.75 6.04 2.75 9C2.75 9.41 2.41 9.75 2 9.75Z"
        fill="#FFFFFF"
      ></path>
      <path
        d="M14.8 12.6292V15.5692C14.8 18.0192 13.82 18.9992 11.37 18.9992H8.43C5.98 18.9992 5 18.0192 5 15.5692V12.6292C5 10.1792 5.98 9.19922 8.43 9.19922H11.37C13.82 9.19922 14.8 10.1792 14.8 12.6292Z"
        fill="#FFFFFF"
      ></path>
      <path
        d="M15.5709 5H12.6309C10.2209 5 9.24094 5.96 9.21094 8.32H11.3709C14.3109 8.32 15.6709 9.69 15.6709 12.62V14.78C18.0409 14.75 18.9909 13.77 18.9909 11.36V8.43C19.0009 5.98 18.0209 5 15.5709 5Z"
        fill="#FFFFFF"
      ></path>
    </g>
  </svg>
);

export const LogoutIcon = (
  <svg
    width="20"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.2222 1H10.7778V13.2222H13.2222V1ZM19.1256 3.65222L17.39 5.38778C19.3211 6.94 20.5556 9.32333 20.5556 12C20.5556 16.73 16.73 20.5556 12 20.5556C7.27 20.5556 3.44444 16.73 3.44444 12C3.44444 9.32333 4.67889 6.94 6.59778 5.37556L4.87444 3.65222C2.50333 5.66889 1 8.65111 1 12C1 18.0744 5.92556 23 12 23C18.0744 23 23 18.0744 23 12C23 8.65111 21.4967 5.66889 19.1256 3.65222Z"
      fill="#FF0000"
      stroke="#FF0000"
      strokeWidth="0.5"
    />
  </svg>
);

export const RegistrationIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M11.5 12.25C14.5376 12.25 17 9.78757 17 6.75C17 3.71243 14.5376 1.25 11.5 1.25C8.46243 1.25 6 3.71243 6 6.75C6 9.78757 8.46243 12.25 11.5 12.25Z"
      fill="white"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M12.931 21.762C11.849 20.6069 11.2479 19.0828 11.25 17.5C11.25 15.819 11.915 14.293 12.995 13.169C12.4976 13.1311 11.9989 13.1121 11.5 13.112C8.178 13.112 5.237 13.943 3.411 15.188C2.018 16.138 1.25 17.345 1.25 18.612V20.063C1.25 20.5139 1.42911 20.9463 1.74792 21.2651C2.06673 21.5839 2.49913 21.763 2.95 21.763L12.931 21.762Z"
      fill="white"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M17.5 12.25C14.602 12.25 12.25 14.602 12.25 17.5C12.25 20.398 14.602 22.75 17.5 22.75C20.398 22.75 22.75 20.398 22.75 17.5C22.75 14.602 20.398 12.25 17.5 12.25ZM18.25 16.75V15.75C18.25 15.5511 18.171 15.3603 18.0303 15.2197C17.8897 15.079 17.6989 15 17.5 15C17.3011 15 17.1103 15.079 16.9697 15.2197C16.829 15.3603 16.75 15.5511 16.75 15.75V16.75H15.75C15.5511 16.75 15.3603 16.829 15.2197 16.9697C15.079 17.1103 15 17.3011 15 17.5C15 17.6989 15.079 17.8897 15.2197 18.0303C15.3603 18.171 15.5511 18.25 15.75 18.25H16.75V19.25C16.75 19.4489 16.829 19.6397 16.9697 19.7803C17.1103 19.921 17.3011 20 17.5 20C17.6989 20 17.8897 19.921 18.0303 19.7803C18.171 19.6397 18.25 19.4489 18.25 19.25V18.25H19.25C19.4489 18.25 19.6397 18.171 19.7803 18.0303C19.921 17.8897 20 17.6989 20 17.5C20 17.3011 19.921 17.1103 19.7803 16.9697C19.6397 16.829 19.4489 16.75 19.25 16.75H18.25Z"
      fill="white"
    />
  </svg>
);

export const CourseIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <g clip-path="url(#clip0_7027_21925)">
      <path
        d="M11.3029 8.34291L6.70758 6.73425C6.70758 8.203 6.69515 8.19259 6.74133 8.33119C6.77332 8.43131 6.82737 8.52298 6.89952 8.59942C6.97166 8.67586 7.06004 8.73513 7.15815 8.77286C12.1652 10.6988 11.8131 10.585 12.0001 10.585C12.1854 10.585 11.829 10.7009 16.8415 8.77286C16.9743 8.72199 17.0886 8.63199 17.1691 8.51478C17.2496 8.39757 17.2927 8.25867 17.2926 8.11645V6.81115L12.6673 8.35323C12.2239 8.50112 11.744 8.49749 11.3029 8.34291Z"
        fill="white"
      />
      <path
        d="M4.53288 4.45418C4.70214 4.56633 4.13599 4.34423 11.7674 7.01509C11.9144 7.06691 12.0744 7.06823 12.2222 7.01885L18.7103 4.856V8.82255C18.7103 9.01666 18.789 9.19295 18.9166 9.32001C19.3572 9.76074 20.1168 9.44698 20.1168 8.82255C20.1168 4.02719 20.1156 3.91874 20.1154 3.91935C20.1366 3.61942 19.9476 3.31706 19.6358 3.21311C12.1276 0.71057 12.1666 0.706116 11.9999 0.706116C11.827 0.706116 11.8772 0.707569 4.7073 3.21639C4.17242 3.40356 4.06627 4.12049 4.53288 4.45418ZM4.23047 15.5249H5.6483V16.9423H4.23047V15.5249Z"
        fill="white"
      />
      <path
        d="M23.2967 3.88031H21.5235V8.82256C21.5235 9.98627 20.5769 10.9324 19.4136 10.9324C18.6648 10.9324 18.0061 10.5405 17.6315 9.95111C17.4377 10.061 17.7595 9.92696 12.7577 11.8509C12.27 12.0386 11.73 12.0386 11.2423 11.8509L6.65312 10.0857C6.25507 9.93263 5.91276 9.66252 5.67135 9.31096C5.42995 8.9594 5.3008 8.54292 5.30093 8.11646V6.24243L4.24271 5.87156C3.39736 5.57618 2.82957 4.77583 2.82957 3.88031H0.70329C0.315074 3.88031 0 4.19538 0 4.5836V19.7667C0 20.1549 0.315074 20.47 0.70329 20.47H7.06042V21.8873H4.93944C4.55122 21.8873 4.23615 22.2024 4.23615 22.5906C4.23615 22.9793 4.55122 23.2939 4.93944 23.2939H19.0606C19.4488 23.2939 19.7639 22.9793 19.7639 22.5906C19.7639 22.2024 19.4488 21.8873 19.0606 21.8873H16.9395V20.47H23.2967C23.6849 20.47 24 20.1549 24 19.7667V4.5836C24 4.19538 23.6849 3.88031 23.2967 3.88031ZM7.05494 17.6456C7.05494 18.0343 6.73986 18.3489 6.35165 18.3489H3.52723C3.13902 18.3489 2.82394 18.0343 2.82394 17.6456V14.8216C2.82394 14.4329 3.13902 14.1183 3.52723 14.1183H6.35165C6.73986 14.1183 7.05494 14.4329 7.05494 14.8216V17.6456ZM20.4728 18.3489H9.17559C8.78737 18.3489 8.4723 18.0343 8.4723 17.6456C8.4723 17.2574 8.78737 16.9423 9.17559 16.9423H20.4728C20.861 16.9423 21.1761 17.2574 21.1761 17.6456C21.1761 18.0343 20.861 18.3489 20.4728 18.3489ZM20.4728 15.5249H9.17559C8.78737 15.5249 8.4723 15.2098 8.4723 14.8216C8.4723 14.4329 8.78737 14.1183 9.17559 14.1183H20.4728C20.861 14.1183 21.1761 14.4329 21.1761 14.8216C21.1761 15.2098 20.861 15.5249 20.4728 15.5249Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_7027_21925">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const TestIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M1.41176 2.35294V21.6471C1.41176 22.1669 1.83314 22.5882 2.35294 22.5882H15.5294V23.0588C15.5294 23.5786 15.108 24 14.5882 24H0.941176C0.421379 24 0 23.5786 0 23.0588V3.29412C0 2.77432 0.421379 2.35294 0.941176 2.35294H1.41176Z"
      fill="white"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M16.9412 0C17.461 0 17.8824 0.421379 17.8824 0.941176V10.3061C16.1419 12.047 14.405 13.7857 12.6682 15.5294H9.41176V16.2353H12.2339C12.1614 16.4706 12.0892 16.7058 12.0179 16.9412H9.41176V17.6471H11.807C11.6402 18.2114 11.4783 18.7757 11.3254 19.3401C11.1668 19.9249 11.6328 20.3608 12.2077 20.2022C13.1395 19.9445 14.0813 19.697 15.0032 19.3897C15.3898 19.2509 15.7964 19.0328 16.0938 18.7454C16.6916 18.1576 17.2876 17.5676 17.8824 16.9766V20.7059C17.8824 21.2257 17.461 21.6471 16.9412 21.6471H3.29412C2.77432 21.6471 2.35294 21.2257 2.35294 20.7059V0.941176C2.35294 0.421379 2.77432 0 3.29412 0H16.9412ZM4.23529 14.5882C3.9754 14.5882 3.76471 14.7989 3.76471 15.0588V18.8235C3.76471 19.0834 3.9754 19.2941 4.23529 19.2941H8C8.2599 19.2941 8.47059 19.0834 8.47059 18.8235V15.0588C8.47059 14.7989 8.2599 14.5882 8 14.5882H4.23529ZM4.23529 8.47059C3.9754 8.47059 3.76471 8.68128 3.76471 8.94118V12.7059C3.76471 12.9658 3.9754 13.1765 4.23529 13.1765H8C8.2599 13.1765 8.47059 12.9658 8.47059 12.7059V8.94118C8.47059 8.68128 8.2599 8.47059 8 8.47059H4.23529ZM9.41176 11.5294H12.2353V10.8235H9.41176V11.5294ZM9.41176 10.1176H15.0588V9.41176H9.41176V10.1176ZM4.23529 2.35294C3.9754 2.35294 3.76471 2.56363 3.76471 2.82353V6.58824C3.76471 6.84813 3.9754 7.05882 4.23529 7.05882H8C8.2599 7.05882 8.47059 6.84813 8.47059 6.58824V2.82353C8.47059 2.56363 8.2599 2.35294 8 2.35294H4.23529ZM9.41176 5.41176H12.2353V4.70588H9.41176V5.41176ZM9.41176 4H15.0588V3.29412H9.41176V4Z"
      fill="white"
    />
    <path
      d="M4.70588 3.52941C4.70588 3.39946 4.81123 3.29412 4.94118 3.29412H7.29412C7.42407 3.29412 7.52941 3.39946 7.52941 3.52941V5.88235C7.52941 6.0123 7.42407 6.11765 7.29412 6.11765H4.94118C4.81123 6.11765 4.70588 6.0123 4.70588 5.88235V3.52941Z"
      fill="white"
    />
    <path
      d="M4.70588 9.64706C4.70588 9.51711 4.81123 9.41176 4.94118 9.41176H7.29412C7.42407 9.41176 7.52941 9.51711 7.52941 9.64706V12C7.52941 12.1299 7.42407 12.2353 7.29412 12.2353H4.94118C4.81123 12.2353 4.70588 12.1299 4.70588 12V9.64706Z"
      fill="white"
    />
    <path
      d="M4.70588 15.7647C4.70588 15.6348 4.81123 15.5294 4.94118 15.5294H7.29412C7.42407 15.5294 7.52941 15.6348 7.52941 15.7647V18.1176C7.52941 18.2476 7.42407 18.3529 7.29412 18.3529H4.94118C4.81123 18.3529 4.70588 18.2476 4.70588 18.1176V15.7647Z"
      fill="white"
    />
    <path
      d="M18.9266 9.9199C19.8287 10.822 20.7067 11.7079 21.6088 12.61C21.5524 12.6744 21.4799 12.755 21.3994 12.8355C19.4904 14.7444 17.5895 16.6613 15.6645 18.554C15.4228 18.7876 15.0926 18.9648 14.7785 19.0776C14.0294 19.3272 13.2642 19.5286 12.507 19.738C12.0399 19.8669 11.6613 19.5125 11.7902 19.0373C12.0238 18.1755 12.2815 17.3137 12.5473 16.4519C12.6037 16.2747 12.7245 16.1055 12.8534 15.9686C14.8429 13.9712 16.8324 11.9818 18.8299 9.98433C18.8541 9.97628 18.8863 9.95212 18.9266 9.9199ZM22.229 11.9898C21.3269 11.0797 20.4409 10.1937 19.579 9.31583C20.022 8.85674 20.4731 8.33322 20.9805 7.88218C21.5282 7.39087 22.3579 7.42309 22.9217 7.9144C23.1714 8.13186 23.405 8.36543 23.6224 8.61512C24.1218 9.18697 24.1299 10.0488 23.6224 10.6126C23.1794 11.0878 22.6962 11.5227 22.229 11.9898Z"
      fill="white"
    />
  </svg>
);
